// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  background: var(--white);
  padding: 3rem 4rem 4rem;
  border-radius: 0.8rem;
  display: block;
}

.divider {
  padding-bottom: 2rem;
  border-bottom: 0.1rem solid var(--grey-border);
}

.title {
  font-size: 2rem;
  line-height: 2.4rem;
  color: var(--black);
}

.desc {
  font-size: 1.4rem;
  line-height: 1.7rem;
  margin-top: 0.5rem;
  color: var(--grey-icon);
}

.content {
  padding-top: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/shared/private-office-block/private-office-block.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,8CAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[":host {\n  width: 100%;\n  background: var(--white);\n  padding: 3rem 4rem 4rem;\n  border-radius: 0.8rem;\n  display: block;\n}\n\n.divider {\n  padding-bottom: 2rem;\n  border-bottom: 0.1rem solid var(--grey-border);\n}\n\n.title {\n  font-size: 2rem;\n  line-height: 2.4rem;\n  color: var(--black);\n}\n\n.desc {\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n  margin-top: 0.5rem;\n  color: var(--grey-icon);\n}\n\n.content {\n  padding-top: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
